import Footer from "components/footer/Footer";
import "./thank-you.scss";

export default function ThankYou() {
  return (
    <>
      <div className="thankyou">
        <div className="thankyou-wrapper">
          <p className="thankyou-wrapper__header">Check your inbox</p>
          <p className="thankyou-wrapper__sub-header">Follow instructions in your email</p>
          <a href="/forgotpassword" className="thankyou-wrapper__link">
            Resend link
          </a>
        </div>
      </div>
      <div className="thankyou-footer">
        <Footer />
      </div>
    </>
  );
}